import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "h3, heading, headline" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M8.99984 3V8M8.99984 8V13M8.99984 8H1.6665M1.6665 3V8M1.6665 8V13M11.8332 7.75C12.1266 7.30165 12.6749 7 13.303 7C14.2401 7 14.9998 7.67157 14.9998 8.5C14.9998 9.32843 14.2401 10 13.303 10C14.2401 10 14.9998 10.6716 14.9998 11.5C14.9998 12.3284 14.2401 13 13.303 13C12.6749 13 12.1266 12.6984 11.8332 12.25",
        stroke: "#7F7F83",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], -1)
  ])))
}
export default { render: render }